import { render, staticRenderFns } from "./detail-popup.vue?vue&type=template&id=036feff6&scoped=true&"
import script from "./detail-popup.vue?vue&type=script&lang=js&"
export * from "./detail-popup.vue?vue&type=script&lang=js&"
import style0 from "./detail-popup.vue?vue&type=style&index=0&id=036feff6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036feff6",
  null
  
)

export default component.exports